import React from 'react';

import { Box, Link, Typography } from '@mui/material';

const getUrl = (offerId: string) => {
  return `${window.location.origin}/tours/details/tour-${offerId}`;
};

const getSalesforceDepartureUrl = (departureSalesforceBk: string) => {
  return `https://luxgroup.lightning.force.com/lightning/r/Season_Depatures__c/${departureSalesforceBk}/view`;
};

type ToursIdsRow = {
  offer_bk: string;
  offer_salesforce_bk: string | null;
  departure_salesforce_bk?: string | null;
  departure_name: string;
  cloned_from_departure_salesforce_bk?: string | null;
  cloned_from_departure_name?: string | null;
};

export default function ToursIdsFormatter({ row }: { row: ToursIdsRow }) {
  const offerId = row.offer_bk?.trim();
  const departureSalesforceBk = row.departure_salesforce_bk?.trim();
  const clonedFromDepartureSalesforceBk = row.cloned_from_departure_salesforce_bk?.trim();

  return (
    <Box sx={{ alignSelf: 'flex-start', py: 1, wordBreak: 'break-all' }}>
      <Typography variant="body2" fontWeight="bold">
        Offer ID:
      </Typography>
      <Typography variant="body2">
        {offerId ? (
          <Link href={getUrl(offerId)} target="_blank" rel="noopener noreferrer" underline="hover">
            {offerId}
          </Link>
        ) : (
          '—'
        )}
      </Typography>
      <Typography variant="body2" fontWeight="bold" sx={{ mt: 0.5 }}>
        Salesforce ID:
      </Typography>
      <Typography variant="body2">{row.offer_salesforce_bk || '—'}</Typography>
      <Typography variant="body2" fontWeight="bold" sx={{ mt: 0.5 }}>
        Departure Name:
      </Typography>
      <Typography variant="body2">
        {departureSalesforceBk && row.departure_name ? (
          <Link
            href={getSalesforceDepartureUrl(departureSalesforceBk)}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
          >
            {row.departure_name}
          </Link>
        ) : (
          row.departure_name || '—'
        )}
      </Typography>
      {clonedFromDepartureSalesforceBk && (
        <>
          <Typography variant="body2" fontWeight="bold" sx={{ mt: 0.5 }}>
            Cloned From:
          </Typography>
          <Typography variant="body2">
            <Link
              href={getSalesforceDepartureUrl(clonedFromDepartureSalesforceBk)}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
            >
              {row.cloned_from_departure_name ?? clonedFromDepartureSalesforceBk}
            </Link>
          </Typography>
        </>
      )}
    </Box>
  );
}
